import { useEffect, useMemo, useState } from "react";

export const BREAKPOINTS = {
	mobileMediumToSmall: 482,
	mobileMedium: 644,
	mobile: 720, //on 720 the teams menu is hidden
	tablet: 1100,
	desktop: 1280,
};

export const MEDIA_QUERIES = {
	isMobileMediumToSmall: `(max-width: ${BREAKPOINTS.mobileMediumToSmall}px)`,
	isMobileMedium: `(max-width: ${BREAKPOINTS.mobileMedium}px)`,
	isMobile: `(max-width: ${BREAKPOINTS.mobile}px)`,
	isTablet: `(max-width: ${BREAKPOINTS.tablet}px)`,
	isDesktop: `(min-width: ${BREAKPOINTS.desktop}px)`,
};

export const useResponsiveBreakpoints = () => {
	const queries = useMemo(() => {
		return Object.entries(MEDIA_QUERIES).map(([key, query]) => ({
			key,
			query,
			mql: window.matchMedia(query),
		}));
	}, []);

	const getMatchStates = () =>
		Object.fromEntries(queries.map(({ key, mql }) => [key, mql.matches]));

	const [breakpoints, setBreakpoints] = useState(getMatchStates);

	useEffect(() => {
		const listeners = queries.map(({ key, mql }) => {
			const listener = (event: MediaQueryListEvent) => {
				setBreakpoints((prev) => ({
					...prev,
					[key]: event.matches,
				}));
			};
			mql.addEventListener("change", listener);
			return { mql, listener };
		});

		return () => {
			listeners.forEach(({ mql, listener }) =>
				mql.removeEventListener("change", listener)
			);
		};
	}, [queries]);

	return breakpoints;
};
